import { render } from "./DateSelector.vue?vue&type=template&id=21bacfff&ts=true"
import script from "./DateSelector.vue?vue&type=script&lang=ts"
export * from "./DateSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__